import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import dailyActiveHelperMachines from './daily-active-helper-machines.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'daily-active-helper-machines-controller',
  setup(__props) {

const dashboardChartUtils = useDashboardChartUtils();
const dashboard = useDashboard();
const dailyActiveHelperMachinesConfig = dashboard.gridUtilization.activeHelperMachines;
const options = computed(() => ({
  ...dailyActiveHelperMachinesConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: dailyActiveHelperMachinesConfig,
        chartId: dailyActiveHelperMachinesConfig.value.chartId,
        componentInstance: dailyActiveHelperMachines,
      }),
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(dailyActiveHelperMachines, {
    "chart-options": {
      ..._unref(dailyActiveHelperMachinesConfig),
      options: _unref(options),
    },
    "no-data": _unref(dashboard).metadata.value.gridUtilization.noData.activeHelperMachines
  }, null, 8, ["chart-options", "no-data"]))
}
}

})